import moment from "moment";

// SQL SUM() over zero rows comes back NULL, which the DataSet→JSON layer can
// serialize as {} rather than null — coerce through Number() so an empty
// aggregate reads as "no value" instead of leaking an object into the UI.
export const numOf = (v) => {
  const n = Number(v);
  return Number.isNaN(n) ? 0 : n;
};

export const topItem = (list, labelKey, valueKey) => {
  if (!list?.length) return null;
  const sorted = [...list].sort(
    (a, b) => numOf(b[valueKey]) - numOf(a[valueKey])
  );
  const top = sorted[0];
  const topValue = top && numOf(top[valueKey]);
  if (!top || !topValue) return null;
  const total = list.reduce((sum, item) => sum + numOf(item[valueKey]), 0);
  const percentage = total > 0 ? ((topValue / total) * 100).toFixed(2) : 0;
  return { label: top[labelKey], value: topValue, percentage };
};

export const sumValues = (list, valueKey) =>
  (list || []).reduce((sum, item) => sum + numOf(item[valueKey]), 0);

export const fmt = (n) => (typeof n === "number" ? n.toLocaleString() : n);

// Delta arrows come from backend Task 1613 (DiamondSummaryKPIs). Absent that
// table (older API, or a metric it doesn't cover), cards render the current
// value only — never a faked trend.
export const trendFor = (summaryKPIs, metric) => {
  const row = (summaryKPIs || []).find((r) => r.Metric === metric);
  if (!row || !row.PriorValue) return null;
  const change = ((row.CurrentValue - row.PriorValue) / row.PriorValue) * 100;
  return { change, up: change >= 0 };
};

// Mirrors the backend's prior-period window (Task 1613): same length as the
// selected range, ending the day before it starts.
export const priorPeriodLabel = (dataRangeFrom, dataRangeTo) => {
  if (!dataRangeFrom || !dataRangeTo) return "";
  const from = moment(dataRangeFrom);
  const to = moment(dataRangeTo);
  const durationDays = to.diff(from, "days");
  const priorTo = from.clone().subtract(1, "days");
  const priorFrom = priorTo.clone().subtract(durationDays, "days");
  const sameYear = priorFrom.year() === priorTo.year();
  const fromLabel = priorFrom.format(sameYear ? "MMM D" : "MMM D, YYYY");
  const toLabel = priorTo.format("MMM D, YYYY");
  return `${fromLabel} – ${toLabel}`;
};
